import './IconWithTooltip.css';

import { Tooltip } from '@mui/material';
import React from 'react';
import { generateClassName } from './helpers';

const IconWithTooltip = ({ IconComponent, tooltip, className = null, ...params }) => {
    return (
        <Tooltip title={tooltip} className={generateClassName('icon-with-tooltip', '-container', className)}>
            <IconComponent className={generateClassName('icon-with-tooltip', '-icon', className, {...params})} />
        </Tooltip>
    );
}

export default IconWithTooltip;